// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"4eebcba2","161":"11b51d85","201":"eeac3862","268":"7b058923","365":"b54b4c62","380":"721992e0","499":"598e81e7","818":"f83f1511","995":"bdccc67e"}[chunkId] + ".chunk.js";
};